<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
      <div class="container">
        <h2 class="marathi-font-lg">{{name}}</h2>
        
      </div>
    </div><!-- End Breadcrumbs -->

    <!-- ======= About Section ======= -->
    <section id="about" class="about">
      <div class="container" data-aos="fade-up">

        <div class="row">
          <div class="col-lg-6 order-1 order-lg-2" data-aos="fade-left" data-aos-delay="100">
            <img [src]="image" class="img-fluid boarder-padding"  alt="">
          </div>
          <div class="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
            <h3 class="marathi-font">{{name}}</h3>
            
            <p class="marathi-font" [innerHTML]="discription">
            </p>

          </div>
        </div>

      </div>
    </section><!-- End About Section -->

   

    <!-- ======= Testimonials Section ======= -->
    <section id="testimonials" class="testimonials pb-0 pt-0">
      <div class="container" data-aos="fade-up">

        <div class="section-title pb-0">
          <p class="marathi-font">पंचावतार</p>
        </div>

        <div class="testimonials-slider swiper" data-aos="fade-up" data-aos-delay="100">
          <div class="swiper-wrapper">

            <div class="swiper-slide">
              <div class="testimonial-wrap">
                <div class="testimonial-item">
                  <img src="../assets/images/thm/shrikrishna.jpg" class="testimonial-img" alt="">
                  <h3 class="marathi-font-lg">श्री कृष्ण चक्रवर्ती महाराज</h3>
                  <h4  class="marathi-font">प्रथम कृष्ण</h4>
                  <p class="marathi-font">
                    <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                    "कृष्ण" या शब्दातील 'कृष्' या धातूचा अर्थ वीषद करताना अन्वयकार आपल्या 'नामाचे दहा ठाये' या प्रकरणात म्हणतात 'कृष् हा धातू विलेखनी वर्तेः कर्मराहाटीते व्यावर्तीः ते विलेखनःः कर्मराहाटीते व्यावर्तोणिः दुखसाधनालागी जनातें व्यवहारापासौनि आकर्षीः म्हणिजे ओढुनी काढीः तो कृष्णःः तोची प्रतीयुगी पंचकृष्णःः म्हणुनच पांचही अवतारांना पंचकृष्ण म्हणुन संबोधण्यात येते.
                    महानुभावपंथात श्रीकृष्णचक्रवर्तींचा अवतार हा द्वापार युगात पीता वसुदेवापासून माता देवकी यांच्या गर्भी जन्मलेला गर्भीचा अवतार होय. पौराणीक कल्पनेप्रमाणे किंवा इतर सांप्रदायांच्या मताप्रमाणे महानुभाव पंथियांना...
                    <a routerLink='/panchakrushna/4' (click)="showDetails('4')" class="default-button" >Read more</a>
                    <i class="bx bxs-quote-alt-right quote-icon-right"></i>
                  </p>
                </div>
              </div>
            </div><!-- End testimonial item -->

            <div class="swiper-slide">
                <div class="testimonial-wrap">
                  <div class="testimonial-item">
                    <img src="../assets/images/thm/dattaprabhu.jpg" class="testimonial-img" alt="">
                    <h3 class="marathi-font-lg">श्री दत्तात्रेय प्रभू</h3>
                    <h4  class="marathi-font">द्वितीय कृष्ण</h4>
                    <p class="marathi-font">
                      <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                      महानुभावपंथात श्रीदत्तात्रेयप्रभूंचा अवतार हा त्रेता युगात पीता अत्रीऋषीपासून माता अनसूया यांच्या गर्भी जन्मलेला गर्भीचा अवतार होय. पौराणीक कल्पनेप्रमाणे किंवा इतर सांप्रदायांच्या मताप्रमाणे महानुभाव पंथियांना श्रीदत्तात्रेयप्रभूंचा हा अवतार ब्रम्हा-विष्णू-महेश यांचा 'तीन शीरे सहा हात असा एकत्र बांधा होय' हे मत मान्य नसून ते त्याला परब्रम्ह परमेश्वरावतार व संपूर्ण उभयदृश्यावतार माणतात. तद्वतच महानुभाव या अवतारास चतुर्भुज न माणता, 'मनुष्यवेषधारी होती' या श्रीचक्रधरस्वामींच्या उक्तीप्रमाणे द्विभूजच माणतात. ही दोन्ही मते महानुभाव पंथियांची श्रीदत्तात्रेयप्रभूंच्या अवताराबाबतची मोठी मत भिन्नता स्पष्ट करतात...
                      <a routerLink='/panchakrushna/2' (click)="showDetails('2')" class="default-button" >Read more</a>
                      <i class="bx bxs-quote-alt-right quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </div><!-- End testimonial item -->

              <div class="swiper-slide">
                <div class="testimonial-wrap">
                  <div class="testimonial-item">
                    <img src="../assets/images/thm/ShriChakrapaniMaharaj.jpg" class="testimonial-img" alt="">
                    <h3 class="marathi-font-lg">श्री चक्रपाणी महाराज</h3>
                    <h4  class="marathi-font">तिसरे कृष्ण</h4>
                    <p class="marathi-font">
                      <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                      महानुभावपंथात द्वारावतीकार श्रीचक्रपाणी महाराजांचा अवतार हा कळीयुगात पीता जनकनायकापासून माता जनकईसा यांच्या गर्भी कर्हाडे ब्राम्हण कुटुंबात जन्मलेला गर्भीचा अवतार होय. महानुभाव पंथियांच्या मताप्रमाणे हा परमेश्वरावतार असुन आछादनीचा अवरदृश्यावतार होय. श्रीदत्तात्रेयप्रभू यांचे पासून माहुर येथे उभयशक्तींचा स्विकार करुन यांनी आपल्या अवतार कार्यास सुरुवात केली. शक्तींस्विकारानंतर माहुर येथे सहा महीने वास्तव्य करूण यात्रेकरूंच्या पव्ह्यासोबत त्यांनी द्वारावतीला प्रयाण केले व त्यानंतर आपल्या दैनंदीन आयुष्याची ६३वर्षे त्यांनी आपल्या ज्ञानदानाचे, समता व सामाजीक क्रांतीचा कृतीपर संदेश देन्याचे कार्य अखंड सुरु ठेवले...
                      <a routerLink='/panchakrushna/6' (click)="showDetails('6')"  class="default-button" >Read more</a>
                      <i class="bx bxs-quote-alt-right quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </div><!-- End testimonial item -->

              <div class="swiper-slide">
                <div class="testimonial-wrap">
                  <div class="testimonial-item">
                    <img src="../assets/images/thm/govindprabhu.jpg" class="testimonial-img" alt="">
                    <h3 class="marathi-font-lg">श्री गोविंद प्रभू</h3>
                    <h4  class="marathi-font">चवाथे कृष्ण</h4>
                    <p class="marathi-font">
                      <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                      महानुभावपंथात श्रीगोविंदप्रभू महाराजांचा अवतार हा कळीयुगात पीता अनंतनायकापासून माता नेमाइसा यांच्या गर्भी काण्व शाखीय ब्राम्हण कुटुंबात जन्मलेला दवडन्याच्या प्रकारातला अवतार होय. महानुभाव पंथियांच्या मताप्रमाणे हा परमेश्वरावतार असुन आछादनीचा परदृश्यावतार होय. श्रीचक्रपाणी महाराजांपासून द्वारावती येथे उभयशक्तींचा स्विकार करुन यांनी आपल्या अवतार कार्यास सुरुवात केली. शक्तींस्विकारानंतर त्यांनी रुद्धपूर प्रयाण केले व त्यानंतर आपल्या दैनंदीन आयुष्याची ८८वर्षे त्यांनी समता व सामाजीक क्रांतीचा कृतीपर संदेश देन्याचे कार्य अखंड सुरु ठेवले...
                      <a routerLink='/panchakrushna/5' (click)="showDetails('5')"  class="default-button" >Read more</a>
                      <i class="bx bxs-quote-alt-right quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </div><!-- End testimonial item -->

              <div class="swiper-slide">
                <div class="testimonial-wrap">
                  <div class="testimonial-item">
                    <img src="../assets/images/thm/chakradharswami.jpg" class="testimonial-img" alt="">
                    <h3 class="marathi-font-lg">श्री चक्रधर स्वामी</h3>
                    <h4  class="marathi-font">सर्वज्ञ (पाचवे कृष्ण)</h4>
                    <p class="marathi-font">
                      <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                      महानुभावपंथात श्रीचक्रधरस्वामी अवतार हा कळीयुगात गुजराथेतील विशालदेव नावाच्या प्रधानाचा पूत्र हरीपाळदेव याचे पतीत(मृतदेह) स्विकारुन झालेला अवतार होय. महानुभाव पंथियांच्या मताप्रमाणे हा परमेश्वरावतार असुन संपूर्ण उभयदृश्यावतार होय. श्रीगुंडमराऊळ महाराजांपासून रुद्धपूर येथे उभयशक्तींचा स्विकार करुन यांनी आपल्या अवतार कार्यास सुरुवात केली. शक्तींस्विकारानंतर त्यांनी वैराग्य धारन केले व त्यानंतर काहीच वर्षात त्यांनी महराष्ट्रात परत येउन व पूढे येथेच राहुन ज्ञानदानाचे, व सामाजीक वीषमता दूर दरण्याचे कार्य अखंड सुरु ठेवले....
                      <a routerLink='/panchakrushna/3' (click)="showDetails('3')"  class="default-button" >Read more</a>
                      <i class="bx bxs-quote-alt-right quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </div><!-- End testimonial item -->

          </div>
          <div class="swiper-pagination"></div>
        </div>

      </div>
    </section><!-- End Testimonials Section -->

  </main><!-- End #main -->